import S from './DriversAlertsCountWidgetStyles';
import EntityRating from '../common/EntityRating/EntityRating';
import { getSimpleGreaterQuery, queryFilterByGroups, queryFilters } from '../../utils/queryFilters';
import { resolveFreshQueryResults } from '../../utils/resolveFreshQueryResults';
import GlobalSpinner from '../common/GlobalSpinner/GlobalSpinner';
import useGetDrivers from '../../API/hooks/drivers/useGetDrivers';
import { TimePeriod } from '../../constants/TimePeriod';

type Props = {
  fleetId: string;
  period: string;
  groupFilters?: Record<string, any>;
};

type AlertCountField = 'alertCountDaily' | 'alertCountWeekly' | 'alertCountMonthly';

const PERIOD_TO_ALERT_FIELD: Record<string, AlertCountField> = {
  daily: 'alertCountDaily',
  weekly: 'alertCountWeekly',
  monthly: 'alertCountMonthly',
};

function DriversAlertsCountWidget({
  fleetId, period = 'monthly', groupFilters,
}: Props): JSX.Element {
  const alertCountField: AlertCountField = PERIOD_TO_ALERT_FIELD[period] ?? 'alertCountMonthly';
  const periodLabel = (TimePeriod as any)[period] ?? TimePeriod.all;

  const {
    data: topDrivers,
    isLoading: isTopLoading,
    isPreviousData: isTopPreviousData,
  } = useGetDrivers(fleetId, `${queryFilters({
    sortBy: [`${alertCountField}_ASC`],
  }, 1, queryFilterByGroups(groupFilters), '', 3)}${getSimpleGreaterQuery('distanceInKmTotal', 0, 1)}`);

  const {
    data: lowDrivers,
    isLoading: isLowLoading,
    isPreviousData: isLowPreviousData,
  } = useGetDrivers(fleetId, `${queryFilters({
    sortBy: [`${alertCountField}_DESC`],
  }, 1, queryFilterByGroups(groupFilters), '', 3)}${getSimpleGreaterQuery('distanceInKmTotal', 0, 1)}`);

  if (isTopLoading && isLowLoading) {
    return (
      <S.Wrapper>
        <GlobalSpinner />
      </S.Wrapper>
    );
  }

  return (
    <S.Wrapper>
      <EntityRating
        title={`High performing drivers • ${periodLabel}`}
        entities={period === 'custom' ? [] : resolveFreshQueryResults(topDrivers, isTopPreviousData)}
        ratingField={alertCountField}
        entityType="driver"
        isLoading={isTopLoading}
        emptyMessage={period === 'custom' ? 'No data available for custom period' : undefined}
      />
      <div className="horizont-line" />
      <EntityRating
        title={`Low performing drivers • ${periodLabel}`}
        entities={period === 'custom' ? [] : resolveFreshQueryResults(lowDrivers, isLowPreviousData)}
        ratingField={alertCountField}
        entityType="driver"
        isLoading={isLowLoading}
        emptyMessage={period === 'custom' ? 'No data available for custom period' : undefined}
      />
    </S.Wrapper>
  );
}

export default DriversAlertsCountWidget;
